import { render, staticRenderFns } from "./RssFeedManagement.vue?vue&type=template&id=2cc02c3c&scoped=true"
import script from "./RssFeedManagement.vue?vue&type=script&lang=js"
export * from "./RssFeedManagement.vue?vue&type=script&lang=js"
import style0 from "./RssFeedManagement.vue?vue&type=style&index=0&id=2cc02c3c&prod&lang=css"
import style1 from "./RssFeedManagement.vue?vue&type=style&index=1&id=2cc02c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc02c3c",
  null
  
)

export default component.exports